// extracted by mini-css-extract-plugin
export default {"list":"BetList_list__U7vZ1"};